import React, { useState, useEffect } from 'react';
import { AuthShell, TalkuSymbol } from './Login';

// /restablecer?t=TOKEN — crea la contraseña nueva con el enlace que llega por correo (backend password_reset.py)

const API = 'https://talku.online';
const score = (v) => { if (!v) return 0; let s = 0; if (v.length >= 8) s++; if (/[A-Z]/.test(v) && /[a-z]/.test(v)) s++; if (/\d/.test(v)) s++; if (/[^A-Za-z0-9]/.test(v) || v.length >= 12) s++; return Math.max(1, s); };

export default function ResetPassword() {
  const token = new URLSearchParams(window.location.search).get('t') || '';
  const [state, setState] = useState('checking'); // checking | ok | invalid | done
  const [pass, setPass] = useState('');
  const [pass2, setPass2] = useState('');
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) { setState('invalid'); return; }
    fetch(`${API}/auth/password/check?t=${encodeURIComponent(token)}`).then(r => r.json()).then(d => setState(d.valid ? 'ok' : 'invalid')).catch(() => setState('invalid'));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault(); setError('');
    if (pass.length < 8) return setError('La contraseña debe tener al menos 8 caracteres');
    if (pass !== pass2) return setError('Las contraseñas no coinciden');
    setLoading(true);
    try {
      const r = await fetch(`${API}/auth/password/reset`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token, password: pass }) });
      const d = await r.json().catch(() => ({}));
      if (r.ok) setState('done');
      else { setError(typeof d.detail === 'string' ? d.detail : 'No se pudo cambiar la contraseña'); if (/venció|ya se usó/.test(d.detail || '')) setState('invalid'); }
    } catch { setError('Error de conexión. Intenta de nuevo.'); }
    setLoading(false);
  };

  const s = score(pass);
  return (
    <AuthShell>
      <style>{`
        .meter{display:flex;gap:4px;margin-top:6px}.meter i{flex:1;height:3px;border-radius:2px;background:#EFEFEF;transition:background .3s}
        .meter.s1 i:nth-child(-n+1){background:#ef4444}.meter.s2 i:nth-child(-n+2){background:#f59e0b}.meter.s3 i:nth-child(-n+3){background:#84cc16}.meter.s4 i{background:#16a34a}
        .rp-ok{width:46px;height:46px;border-radius:50%;background:#16a34a;display:flex;align-items:center;justify-content:center;margin:0 auto 14px;animation:pop .5s cubic-bezier(.34,1.56,.64,1)}
        @keyframes pop{from{transform:scale(0)}to{transform:scale(1)}}
      `}</style>
      <div className="fbox">
        <div className="f-logo"><TalkuSymbol/></div>
        {state === 'checking' && <p className="f-sub" style={{ textAlign: 'center' }}>Revisando el enlace…</p>}

        {state === 'invalid' && (<>
          <h1 className="f-h">El enlace ya no sirve</h1>
          <p className="f-sub">Venció (dura 30 minutos) o ya se usó. Pide uno nuevo desde el inicio de sesión.</p>
          <a className="btn" href="/login" style={{ textDecoration: 'none' }}>Ir al inicio de sesión</a>
        </>)}

        {state === 'done' && (<>
          <div className="rp-ok"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg></div>
          <h1 className="f-h">Contraseña actualizada</h1>
          <p className="f-sub">Ya puedes entrar a Talku con tu contraseña nueva.</p>
          <a className="btn" href="/login" style={{ textDecoration: 'none' }}>Iniciar sesión</a>
        </>)}

        {state === 'ok' && (
          <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column' }}>
            <h1 className="f-h">Crea tu contraseña nueva</h1>
            <p className="f-sub">Usa al menos 8 caracteres. Mejor si combina letras, números y símbolos.</p>
            <div className="grp">
              <div>
                <label className="lbl" htmlFor="rp-1">Contraseña nueva</label>
                <div className="fld">
                  <input id="rp-1" type={show ? 'text' : 'password'} value={pass} onChange={e => setPass(e.target.value)} required autoComplete="new-password" autoFocus/>
                  <button type="button" className="eye" onClick={() => setShow(v => !v)} aria-label={show ? 'Ocultar contraseña' : 'Mostrar contraseña'}>
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                  </button>
                </div>
                <div className={`meter${s ? ' s' + s : ''}`}><i/><i/><i/><i/></div>
              </div>
              <div>
                <label className="lbl" htmlFor="rp-2">Repite la contraseña</label>
                <div className="fld"><input id="rp-2" type={show ? 'text' : 'password'} value={pass2} onChange={e => setPass2(e.target.value)} required autoComplete="new-password"/></div>
              </div>
            </div>
            {error && <div className="lg-err">{error}</div>}
            <button className="btn" type="submit" disabled={loading}>{loading && <span className="spin"/>}{loading ? 'Guardando…' : 'Guardar contraseña'}</button>
          </form>
        )}
      </div>
    </AuthShell>
  );
}
